import React from 'react';
import moment from 'moment';
import { Text, View, createStyleSheet, useStyleSheet, User } from '@gopeerproject/ui-kit';
import { humanizeDuration } from '../../helpers';
const Participants = ({ data }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: styles.participants },
        data.map((v, i) => (React.createElement(View, { key: v.id, style: i !== 0 ? styles.participants__image__withMargin : {} },
            React.createElement(User, { name: v.name, type: v.type, image: v.image, size: 'sm' })))),
        React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', numberOfLines: 1, style: [styles.participants__name, styles.text__isSelectable], selectable: true }, data.map((v) => v.name).join(', '))));
};
export const Cell = ({ data, style, textStyle }) => {
    const styles = useStyleSheet(getStyles);
    const { type, value } = data;
    return (React.createElement(View, { style: [styles.container, style] }, type === 'participants' ? (React.createElement(Participants, { data: value })) : type === 'time' ? (React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: [textStyle, styles.text__isSelectable], selectable: true, numberOfLines: 1 }, moment(value).format(moment(value).isBefore(moment(), 'year')
        ? 'h:mm A, MMM D, YYYY'
        : 'h:mm A, MMM D'))) : type === 'duration' ? (React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: [textStyle, styles.text__isSelectable], selectable: true, numberOfLines: 1 }, humanizeDuration(value))) : type === 'text' ? (React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: [textStyle, styles.text__isSelectable], selectable: true, numberOfLines: 1 }, value)) : null));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        flexDirection: 'row'
    },
    participants: {
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%'
    },
    participants__name: {
        marginLeft: size.C
    },
    participants__image__withMargin: {
        marginLeft: -12,
        backgroundColor: color.bg.v1,
        borderRadius: 9999
    },
    text__isSelectable: {
        paddingVertical: size.I,
        paddingHorizontal: size.G,
        flexDirection: 'row',
        flex: 1
    }
}));
//# sourceMappingURL=Cell.js.map